<template>
  <div class="flex items-center justify-center p-6 bg-indigo-800">
    <div class="w-full max-w-md">
      <div v-if="myTrips.length" class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden">
        <div class="px-2 py-6"><h1 class="text-center text-3xl font-bold">Предстоящие поездки</h1>
          <div class="mt-6 mx-auto border-b-2"></div>
          <div class="mt-5">
            <div v-for="trip in myTrips" :key="trip.id" class="px-2">
              <div class="flex items-center py-2">
                <div>{{ trip.trip_date }}</div>
                <div class="ml-auto">{{ trip.route.name }}</div>
              </div>
              <div class="flex items-center py-2">
                <div>Авто</div>
                <div class="ml-auto">{{ trip.car.mark }} {{ trip.car.model }} {{ trip.car.color }} {{ trip.car.grn }}!!!</div>
              </div>
              <div class="flex items-center py-2">
                <div></div>
                <button class="flex items-center btn-indigo ml-auto" type="button" @click="view(trip.id)">Посмотреть</button>
              </div>
              <div class="my-3 mx-auto w-24 border-b-2"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="deposit || deposit_enabled" class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden">
        <div class="mt-5 px-5 pb-5">
          <div v-if="deposit" class="flex items-center py-2">
              <div>Ваш депозит:</div>
              <div class="ml-auto">{{ deposit }}руб.</div>
            </div>
          <div v-if="deposit_enabled && deposit < (deposit_amount -50)" class="flex items-center py-2">
            <div>Используйте депозит для гарантированной брони мест! &#10071; депозит - это не предоплата поездки.</div>
          </div>
          <div v-if="deposit_enabled && deposit < (deposit_amount - 50)" class="flex items-center py-2">
              <div></div>
              <button class="flex items-center btn-indigo ml-auto" type="button" @click="addDeposit">Внести депозит</button>
          </div>
        </div>
      </div>
      <div class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden">
        <div class="px-2 py-6"><h1 class="text-center text-3xl font-bold">Открытые поездки</h1>
          <div class="flex items-center justify-between mb-6">
            <label class="block text-gray-700 mr-2">Фильтр:</label>
            <filter class="flex-grow" @reset="reset">
              <select v-model="form.route" class="form-select mt-1 w-full">
                <option :value="null"/>
                <option v-for="route in routes" :key="route.id" :value="route.id">{{ route.name }}</option>
              </select>
            </filter>
          </div>
          <div class="mt-6 mx-auto border-b-2"></div>
          <div v-for="(dayWithTrips, tripDate) in trips" :key="tripDate">
            <div class="text-2xl text-center font-bold">{{ tripDate }}</div>
            <div class="mt-5">
              <div v-for="trip in dayWithTrips" :key="trip.id" class="px-2">
                <span class="font-bold">{{ trip.trip_time }}</span> |
                <span>{{ trip.route.departure }}</span> - <span>{{ trip.route.destination }}</span>
                <div class="flex items-center py-2">
                  <div>{{ trip.car.mark }} {{ trip.car.model }} {{ trip.car.color }}</div>
                  <div class="ml-auto">{{ trip.price }}р.</div>
                </div>
                <div v-if="trip.awaited" class="flex items-center py-2">
                  <div class="m-auto" style="color: red">Вы в списке ожидания</div>
                </div>
                <div v-if="trip.available_seats <= 0" class="flex items-center py-2">
                  <button class="text-black-600 hover:underline" type="button">ЛИСТ ОЖИДАНИЯ. Бронируйте в поездке</button>
                  <button class="flex items-center btn-indigo ml-auto" type="button" @click="view(trip.id)">Посмотреть</button>
                </div>
                <div v-if="trip.available_seats > 0" class="flex items-center py-2">
                  <button class="text-black-600 hover:underline" type="button">ЕСТЬ МЕСТА</button>
                  <button class="flex items-center btn-indigo ml-auto" type="button" @click="view(trip.id)">Посмотреть</button>
                </div>
                <div class="my-3 mx-auto w-24 border-b-2" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Filter from '@/Shared/Filter'

export default {
  components: {
    Filter,
  },
  props: {
    filters: Object,
    trips: Object,
    myTrips: Array,
    routes: Object,
    deposit: Number,
    deposit_enabled: Boolean,
    deposit_amount: Number,
  },
  data() {
    return {
      form: {
        authData: authData ? authData : Telegram.WebApp.initData,
        route: this.filters.route,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.post('/webapp/init', pickBy(this.form), {preserveState: true})
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    view(trip_id) {
      this.$inertia.post('/webapp/client/trip/' + trip_id, {
        authData: authData ? authData : Telegram.WebApp.initData,
      })
    },
    addDeposit() {
      this.$inertia.post('/webapp/client/addDeposit', {
        authData: authData ? authData : Telegram.WebApp.initData,
      })
    }
  },
}
</script>
